/**
 * @generated SignedSource<<e57920877d853e89ae0fae0b61230708>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavExpandingAreaItem_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavItemVATReportLink_seller" | "NavItem_seller">;
  readonly " $fragmentType": "NavExpandingAreaItem_seller";
};
export type NavExpandingAreaItem_seller$key = {
  readonly " $data"?: NavExpandingAreaItem_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItem_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavExpandingAreaItem_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItemVATReportLink_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "964902bb05d5b725689bcb3fc492abf4";

export default node;
